import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';

import { AnchorScrollDirective } from './anchor-scroll/anchor-scroll.directive';
import { ContainerSizeDirective } from './container-size/container-size.directive';
import { FocusTrackerDirective } from './focus-tracker/focus-tracker.directive';
import { FocusTrackerItemDirective } from './focus-tracker/focus-tracker-item.directive';
import { HideDirective } from './hide/hide.directive';
import { HrefDirective } from './href/href.directive';
import { LinkAccessibilityDirective } from './link-accessibility/link-accessibility.directive';
import { ScrollIntoViewDirective } from './scroll-into-view/scroll-into-view.directive';
import { ScreenReaderVisibilityDirective } from './screen-reader-visibility/screen-reader-visibility.directive';
import { SideSheetDirective } from './side-sheet/side-sheet.directive';
import { SideSheetSwipeDirective } from './side-sheet/side-sheet-swipe.directive';
import { PhoneNumberValidatorDirective } from './phone-validator/phone-number-validator.directive';

@NgModule({
  imports: [
    AngularCore,
    AnchorScrollDirective,
    ContainerSizeDirective,
    FocusTrackerDirective,
    FocusTrackerItemDirective,
    HideDirective,
    HrefDirective,
    LinkAccessibilityDirective,
    ScrollIntoViewDirective,
    ScreenReaderVisibilityDirective,
    SideSheetDirective,
    SideSheetSwipeDirective,
    PhoneNumberValidatorDirective
  ],
  exports: [
    AnchorScrollDirective,
    ContainerSizeDirective,
    FocusTrackerDirective,
    FocusTrackerItemDirective,
    HideDirective,
    HrefDirective,
    LinkAccessibilityDirective,
    ScrollIntoViewDirective,
    ScreenReaderVisibilityDirective,
    SideSheetDirective,
    SideSheetSwipeDirective,
    PhoneNumberValidatorDirective
  ]
})
export class DirectivesModule {
}
